import { AppEnvironment } from 'projects/config/model/environment.model';

const host = location.host;
const isLocalhost = host.startsWith('localhost');
const isQA = isLocalhost || host.startsWith('qa.');
const isDEV = isLocalhost || host.startsWith('devsp.');
const isRC = isLocalhost || host.startsWith('sandboxefeso.') || host.startsWith('sandboxrevamp.') || host.startsWith('sandboxrt.');
const isDEMO = isLocalhost || host.startsWith('demo.');
const isPROD = isLocalhost || (!isQA && !isDEV && !isRC && !isDEMO);
const isGeneric = isLocalhost || host.startsWith('www.') || host === 'solvacelabs.com';

export const environment: AppEnvironment = {
  isLocalhost,
  isQA,
  isDEV,
  isDEVorQA: isQA || isDEV,
  isRC,
  isDEMO,
  isPROD,
  isGeneric,
  sentryDsn: 'https://b7c1aa4e6e6adb9a937e0c6b6108cc6f@o4507857881726976.ingest.us.sentry.io/4510268572368896',
  datadogRum: {
    applicationId: '1e18a5a1-73cc-4892-88ff-34f98864eecf',
    clientToken: 'pub03a5f3703612ea16ae7a2491f712e49e',
  },
  production: false,
  APIs: {
    apiUrlAuth: 'https://apigw-dev.solvacelabs.com/authentication',
    apiUrlAuthSignalR: 'https://api-authentication-ws-dev.solvacelabs.com',
    apiUrlUsers: 'https://api-users-dev.solvacelabs.com',
    apiUrlActionPlan: 'https://api-actionplan-dev.solvacelabs.com',
    apiUrlChecklist: 'https://api-checklist-dev.solvacelabs.com',
    apiUrlCil: 'https://api-cil-dev.solvacelabs.com',
    apiUrlDefectTag: 'https://api-defecttag-dev.solvacelabs.com',
    apiUrlDefectTagLegacy: 'https://api-defecttag-dev.solvacelabs.com',
    apiUrlObeya: 'https://api-digitalobeya-dev.solvacelabs.com',
    apiUrlAssessment: 'https://api-assessment-dev.solvacelabs.com',
    apiUrlIncident: 'https://api-incident-dev.solvacelabs.com',
    apiUrlComplaint: 'https://api-complaint-dev.solvacelabs.com',
    apiUrlNonconformity: 'https://api-nonconformity-dev.solvacelabs.com',
    apiUrlTraining: 'https://api-training-dev.solvacelabs.com',
    apiUrlGed: 'https://api-documentation-dev.solvacelabs.com',
    apiUrlKnowledgeCenter: 'https://apigw-dev.solvacelabs.com/knowledgecenter',
    apiUrlLpp: 'https://api-lpp-dev.solvacelabs.com',
    apiUrlKaizen: 'https://api-kaizen-dev.solvacelabs.com',
    apiUrlMoc: 'https://api-moc-dev.solvacelabs.com',
    apiUrlWorkpermit: 'https://api-workpermit-dev.solvacelabs.com',
    apiUrlCenterline: 'https://api-centerline-dev.solvacelabs.com',
    apiUrlHashtag: 'https://api-hashtag-dev.solvacelabs.com',
    apiUrlExportFile: 'https://api-digitalobeya-dev.solvacelabs.com',
    apiUrlReaction: 'https://api-reaction-dev.solvacelabs.com',
    apiUrlPraise: 'https://api-praise-dev.solvacelabs.com',
    apiUrlQuiz: 'https://api-quiz-dev.solvacelabs.com',
    apiUrlCommunication: 'https://api-communication-dev.solvacelabs.com',
    apiUrlPosts: 'https://api-post-dev.solvacelabs.com',
    apiUrlAdministration: 'https://apigw-dev.solvacelabs.com/administration',
    apiUrlComments: 'https://api-comment-dev.solvacelabs.com',
    apiUrlCommentManager: 'https://api-commentmanager-dev.solvacelabs.com',
    apiUrlProject: 'https://api-project-dev.solvacelabs.com',
    apiUrlBookmark: 'https://api-bookmark-dev.solvacelabs.com',
    apiUrlNotification: 'https://api-notification-dev.solvacelabs.com',
    apiUrlDocuments: 'https://api-documents-dev.solvacelabs.com',
    apiUrlSurvey: 'https://api-survey-dev.solvacelabs.com',
    apiUrlMasterdata: 'https://api-masterdata-dev.solvacelabs.com',
    apiUrlViews: 'https://api-views-dev.solvacelabs.com',
    apiUrlBOS: 'https://api-bos-dev.solvacelabs.com',
    apiUrlMultilingual: 'https://api-multilingual-dev.solvacelabs.com',
    apiUrlAlert: 'https://api-alert-dev.solvacelabs.com',
    apiUrlGamification: 'https://api-gamification-dev.solvacelabs.com',
    apiUrlSubtitle: 'https://api-subtitle-dev.solvacelabs.com',
    apiUrlCustomField: 'https://api-customfield-dev.solvacelabs.com',
    apiUrlCopilot: 'https://api-copilot-dev.solvacelabs.com',
    apiUrlUnsafeCondition: 'https://api-unsafecondition-dev.solvacelabs.com',
    apiUrlRca: 'https://api-rca-dev.solvacelabs.com',
    apiUrlFishbone: 'https://api-fishbone-dev.solvacelabs.com',
    apiUrlWhyWhy: 'https://api-whywhy-dev.solvacelabs.com',
    apiUrlWhiteBoard: 'https://api-whiteboard-dev.solvacelabs.com',
    apiUrlModuleIntegration: 'https://api-moduleintegration-dev.solvacelabs.com',
    apiUrlScorecard: 'https://api-scorecard-dev.solvacelabs.com',
    apiUrlRcaLegacy: 'https://api-rca-dev.solvacelabs.com',
    apiUrlLppLegacy: 'https://api-lpp-dev.solvacelabs.com',
  },
};
